import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { EducationHostedFormModel, EducationHostedFormSteps } from '../EducationHostedForm.types'
import { useNavigateForm } from '../hooks/useNavigateForm'
import { HasCurrentPageErrorsProps, useHasCurrentPageErrors } from '../hooks/useHasCurrentPageErrors'

import { Step } from '@percent/education-hosted-form/ui/Step/Step'
import { FormField, TextInput, Flex } from '@percent/lemonade'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

export function AddOrganisation() {
  const { t } = useTranslation()
  const { progress } = useEducationHostedForm()
  const { handleNextStep, handlePreviousStep } = useNavigateForm()
  const { register } = useFormContext<EducationHostedFormModel>()

  const inputFields: HasCurrentPageErrorsProps = [{ fieldKey: 'organisationName' }, { fieldKey: 'organisationWebsite' }]

  const { hasPageErrors, errors, getStatus } = useHasCurrentPageErrors(inputFields)

  const handleNext = () => {
    handleNextStep(EducationHostedFormSteps.ORGANISATION_ADDRESS)
  }

  return (
    <Step
      step={EducationHostedFormSteps.ADD_ORGANISATION}
      title={t('addOrganisation.title')}
      description={t('addOrganisation.description')}
      onBack={handlePreviousStep}
      onNext={handleNext}
      nextButtonDisabled={hasPageErrors}
      nextButtonLabel={t('button.next')}
      progress={progress}
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('addOrganisation.organisationName')}
          status={getStatus(errors.organisationName)}
          necessity="required"
          statusMessage={errors.organisationName}
          description={t('addOrganisation.organisationNameDescription')}
        >
          <TextInput {...register('organisationName')} placeholder={t('addOrganisation.organisationNamePlaceholder')} />
        </FormField>
        <FormField
          label={t('addOrganisation.organisationWebsite')}
          status={getStatus(errors.organisationWebsite)}
          necessity="required"
          statusMessage={errors.organisationWebsite}
        >
          <TextInput
            {...register('organisationWebsite')}
            placeholder={t('addOrganisation.organisationWebsitePlaceholder')}
          />
        </FormField>
      </Flex>
    </Step>
  )
}
